import { Star, Shield, Award, Users, CheckCircle } from "lucide-react";
import { Card } from "@/components/ui/card";

const trustSignals = [
  {
    icon: Users,
    value: "1000+",
    label: "Tevreden Klanten",
    description: "Betrouwbare partner sinds 2018"
  },
  {
    icon: Star,
    value: "4.9/5",
    label: "Klantbeoordeling",
    description: "Gebaseerd op 150+ reviews"
  },
  {
    icon: Shield,
    value: "25 Jaar",
    label: "Product Garantie",
    description: "Volledige garantie op alle panelen"
  },
  {
    icon: Award,
    value: "Erkend",
    label: "Installateur",
    description: "Gecertificeerd door ISSO & DEKRA"
  },
  {
    icon: CheckCircle,
    value: "100%",
    label: "EasyStroom Voordeel",
    description: "Geen boetes bij teruglevering"
  }
];

export function TrustSignalsBar() {
  return (
    <section className="py-8 md:py-12 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
            Waarom 1000+ Klanten Kozen Voor SOL-VI
          </h2>
          <p className="text-muted-foreground">
            Vertrouwd door families in heel Gelderland
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {trustSignals.map((signal, index) => {
            const IconComponent = signal.icon;
            return (
              <Card key={index} className="p-4 md:p-6 text-center hover:shadow-card transition-shadow">
                <IconComponent className="h-8 w-8 md:h-10 md:w-10 text-primary mx-auto mb-3" />
                <div className="text-xl md:text-2xl font-bold text-foreground mb-1">
                  {signal.value}
                </div>
                <div className="text-sm md:text-base font-medium text-foreground mb-2">
                  {signal.label}
                </div>
                <div className="text-xs md:text-sm text-muted-foreground">
                  {signal.description}
                </div>
              </Card>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium">
            <Shield className="h-4 w-4" />
            Exclusieve EasyStroom Partner - Geen Teruglevering Boetes
          </div>
        </div>
      </div>
    </section>
  );
}